import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { Link } from 'react-router-dom'
import { UI } from '../config'
import DropdownOpenTray from './DropdownOpenTray'
import Media from './Media'
import '../styles/BreadCrumb.scss'

class BreadCrumb extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
      })
    ),
    variant: PropTypes.oneOf(['default', 'browse-guide']),
    className: PropTypes.string,
  }

  static defaultProps = {
    variant: 'browse-guide',
  }

  buildTrayItems(items) {
    return items.map((item, index) => {
      const isLast = index === items.length - 1
      const isCurrent = isLast || !item.link

      return {
        label: item.title,
        ...(item.link && !isCurrent ? { to: item.link } : {}),
        isCurrent,
      }
    })
  }

  renderDesktopList(items, isBrowseGuide) {
    return (
      <ol className={classNames(isBrowseGuide && 'BreadCrumb-list', !isBrowseGuide && 'topics-breadcrumb')}>
        {items.map((item, index) => {
          const isLast = index === items.length - 1
          const isCurrent = isLast || !item.link

          return (
            <li key={`${item.title}-${index}`} className={classNames(isBrowseGuide && 'BreadCrumb-item')}>
              {isCurrent ? (
                <span className={classNames(isBrowseGuide && 'BreadCrumb-current')}>{item.title}</span>
              ) : (
                <Link to={item.link} className={classNames(isBrowseGuide && 'BreadCrumb-link')}>
                  {item.title}
                </Link>
              )}
            </li>
          )
        })}
      </ol>
    )
  }

  renderMobileDropdown(items) {
    const currentItem = items[items.length - 1]

    return (
      <DropdownOpenTray
        className="DropdownOpenTray--breadcrumb"
        label={currentItem.title}
        items={this.buildTrayItems(items)}
        trayTitle={UI.MOBILE_BREADCRUMB_TRAY_TITLE}
        triggerVariant="text"
      />
    )
  }

  render() {
    const { items, variant, className } = this.props

    if (!items || items.length === 0) {
      return null
    }

    const isBrowseGuide = variant === 'browse-guide'

    if (isBrowseGuide) {
      return (
        <nav className={classNames('BreadCrumb', className)} aria-label="Breadcrumb">
          <Media type="desktop">{this.renderDesktopList(items, isBrowseGuide)}</Media>
          <Media type="mobile">{this.renderMobileDropdown(items)}</Media>
        </nav>
      )
    }

    return (
      <nav className={classNames('topics-breadcrumb', className)} aria-label="Breadcrumb">
        {this.renderDesktopList(items, isBrowseGuide)}
      </nav>
    )
  }
}

export default BreadCrumb
